import React, {useEffect, useState} from "react";
import useSexType from "../Stores/SexStore";

const MAX_SELECTED = 2;

interface SexCompProps {
  onClose?: () => void;
}

const SexComp: React.FC<SexCompProps> = ({onClose}): JSX.Element => {
  const sexCompValue = useSexType((s) => s.sexCompValue);
  const setSexCompValue = useSexType((s) => s.setSexCompValue);
  const sexList = useSexType((s) => s.sexList);

  const [tempSelection, setTempSelection] = useState<number[]>(sexCompValue);

  useEffect(() => {
    setTempSelection(sexCompValue);
  }, [sexCompValue]);

  const toggle = (idx: number) => {
    const next = tempSelection.includes(idx)
      ? tempSelection.filter((i) => i !== idx)
      : [...tempSelection, idx];

    setTempSelection(next);

    if (next.length === MAX_SELECTED) {
      setSexCompValue(next);
      // Close menu when user makes a selection (changes from current state)
      if (
        JSON.stringify(next.sort()) !== JSON.stringify([...sexCompValue].sort())
      ) {
        onClose?.();
      }
    }
  };

  const isDisabled = (idx: number) =>
    !tempSelection.includes(idx) && tempSelection.length >= MAX_SELECTED;

  return (
    <div className="flex flex-col justify-center">
      <ul>
        {sexList.map((label: string, idx: number) => {
          const checked = tempSelection.includes(idx);
          const disabled = isDisabled(idx);
          return (
            <li key={idx}>
              <label className="label cursor-pointer justify-start ml-2 gap-0">
                <input
                  type="checkbox"
                  className="checkbox checkbox-xs checkbox-accent checked::border-accent bg-white"
                  checked={checked}
                  onChange={() => toggle(idx)}
                  disabled={disabled}
                />
                <div
                  className={`ml-2 ${
                    disabled ? "opacity-50" : "text-valmidnight"
                  }`}>
                  {label}
                </div>
              </label>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SexComp;
